import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription }   from 'rxjs/Subscription';
import { ModalService } from './modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {TypeModal } from "../../utils/enumeration";
import { Statique } from '../../utils/statique';


@Component({
	selector: 'app-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.css']
})

export class ModalComponent implements OnInit {
	message: any;
 /*  @Input() message;
	@Input() title;
	@Input() typeModal;
	_typeModal = TypeModal; */

	constructor(public activeModal: NgbActiveModal, private modalService:ModalService) {}
	Statique: Statique;

	ngOnInit() {
		this.modalService.getMessage().subscribe(message => {
			this.message = message;
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.component.ts